import { useEffect } from "react";
import { useConfig } from "@/context/ConfigContext";
import WarpField from "@/components/WarpField";
import { Calendar, ArrowUpRight } from "lucide-react";

export default function Book() {
  const cfg = useConfig();
  const calendlyUrl = cfg.calendly_url;

  // Load Calendly inline widget script
  useEffect(() => {
    if (!calendlyUrl) return;
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
    const link = document.createElement("link");
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    return () => {
      document.body.removeChild(script);
      try { document.head.removeChild(link); } catch (e) {}
    };
  }, [calendlyUrl]);

  return (
    <div className="bg-black min-h-screen anim-fadeup relative overflow-hidden" data-testid="book-page">
      <div className="absolute inset-0 opacity-25 pointer-events-none">
        <WarpField density={100} speed={0.4} />
      </div>

      <section className="relative border-b border-neutral-900 py-20">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
          <div className="font-mono text-[10px] tracking-[0.4em] text-neutral-500 mb-4 flex items-center gap-3">
            <Calendar size={12} /> BOOK A SESSION
          </div>
          <h1 className="font-bodoni font-black text-6xl md:text-8xl lg:text-9xl leading-[0.85]">
            Lock in <span className="italic">a date</span>.
          </h1>
          <p className="mt-6 max-w-2xl font-mono text-sm text-neutral-400 leading-relaxed">
            Pick the slot that works. We'll confirm crew availability and roll into pre-production.
            For complex builds, run the <a href="/onboarding" className="text-white link-underline">mission brief</a> first.
          </p>
        </div>
      </section>

      <section className="relative py-12">
        <div className="max-w-[1100px] mx-auto px-6">
          {calendlyUrl ? (
            <div className="border border-neutral-900 bg-black p-2" data-testid="calendly-embed">
              <div
                className="calendly-inline-widget"
                data-url={`${calendlyUrl}?background_color=000000&text_color=ffffff&primary_color=ffffff&hide_event_type_details=0&hide_gdpr_banner=1`}
                style={{ minWidth: "320px", height: "780px" }}
              />
            </div>
          ) : (
            <div className="border border-neutral-900 p-16 text-center">
              <div className="font-mono text-[10px] text-neutral-600 tracking-[0.3em] mb-3">
                SCHEDULER OFFLINE
              </div>
              <p className="font-bodoni italic text-2xl text-neutral-500">Booking link not configured yet.</p>
              <a href="/contact" className="btn-ghost mt-8 inline-flex">Use Direct Channel <ArrowUpRight size={14} /></a>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
